import css from '@emotion/css'

export const none = css`
  box-shadow: none;
`
export const small = css`
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.06);
`
